<template>
  <div class="detailComplete dis_f_c_c">
    <div class="box">
      <div class="img dis_f_c_c">
        <img class="fit" src="@/images/common/wx-complete.png" alt="" />
      </div>
      <div class="li1 dis_f_c_c">预定支付成功</div>
      <div class="li2 dis_f_c_c">
        供应商会在30分钟内与您确认订舱信息, 请保持信息通常
      </div>
      <div class="li2 dis_f_c_c mb60px">
        【支付成功后】可进入工作台查看支付订舱详情
      </div>
      <div class="dis_f_c_c">
        <div class="li3 dis_f_c_c hand" @click="close()">返回查看其他舱位</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {};
  },
  components: {},
  watch: {},
  computed: {},
  created() {},
  mounted() {
    // 切换页面时滚动条自动滚动到顶部
    window.scrollTo(0, 0);
  },
  methods: {
    // ==============================跳转==============================
    close() {
      let object = {
        orderStatus: 1,
        code_url: "",
        orderId: "",
        order_form: {},
        object: {}, //总对象  包含code_url  orderId
      };
      this.$store.dispatch("order/orderMethods", object);
      this.$router.replace("/reserveCabin");
      // let routeData = this.$router.resolve({
      //   path: "/lookPresentCabinDetail",
      //   query: { id: id },
      // });
      // window.open(routeData.href, "_blank");
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/variable.scss";
.detailComplete {
  width: 100%;
  background: #ffffff;
  min-height: calc(100vh - 138px);
  // min-height: 100%;
  // padding-top: 150px;
  // margin-bottom: 314px;
  .box {
    .img {
      width: 84px;
      height: 84px;
      margin: 0 auto;
      margin-bottom: 26px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .li1 {
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: bold;
      color: #373842;
      margin-bottom: 20px;
    }
    .li2 {
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #676c77;
      line-height: 22px;
    }
    .mb60px {
      margin-bottom: 60px;
    }
    .li3 {
      padding: 12px 18px;
      border-radius: 6px;
      background: var(--themeColor);
      font-size: 14px;
      color: #ffffff;
    }
  }
}
</style>